<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">{{'kiosksync.title'|traduccion}}</h2>
    <div class="header-actions">
      <span class="summary-chip">{{'kiosksync.totalElements'|traduccion}}: {{ totalItems() }}</span>
      <button mat-stroked-button class="refresh-table-button" (click)="loadKioskSyncs()">
        <mat-icon>refresh</mat-icon>
        {{'table.retry'|traduccion}}
      </button>
    </div>
  </div>

  <mat-card class="table-card">
    <app-data-table
      [dataSource]="kioskSyncs"
      [displayedColumns]="displayedColumns"
      [loading]="loading"
      [emptyMessage]="'kiosksync.table.nodata'|traduccion"
      [rowClickable]="true"
      (rowClick)="openDetails($event.row)">
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{'kiosksync.table.header.status'|traduccion}}</th>
        <td mat-cell *matCellDef="let kioskSync">
          <span [class]="statusClass(kioskSync.status)">{{ formatEnumLabel(kioskSync.status) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="aggregate">
        <th mat-header-cell *matHeaderCellDef>{{'kiosksync.table.header.aggregate'|traduccion}}</th>
        <td mat-cell *matCellDef="let kioskSync">
          <div class="aggregate-cell">
            <strong>{{ valueOrDash(kioskSync.aggregateType) }}</strong>
            <code>{{ valueOrDash(kioskSync.aggregateId) }}</code>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="versions">
        <th mat-header-cell *matHeaderCellDef>{{'kiosksync.table.header.versions'|traduccion}}</th>
        <td mat-cell *matCellDef="let kioskSync">{{ versionsLabel(kioskSync) }}</td>
      </ng-container>

      <ng-container matColumnDef="pendingChanges">
        <th mat-header-cell *matHeaderCellDef>{{'kiosksync.table.header.pendingChanges'|traduccion}}</th>
        <td mat-cell *matCellDef="let kioskSync">{{ pendingChangesLabel(kioskSync.hasPendingLocalChanges) }}</td>
      </ng-container>

      <ng-container matColumnDef="lastAckAt">
        <th mat-header-cell *matHeaderCellDef>{{'kiosksync.table.header.lastAckAt'|traduccion}}</th>
        <td mat-cell *matCellDef="let kioskSync">{{ formatDateTime(kioskSync.lastAckAt) }}</td>
      </ng-container>

      <ng-container matColumnDef="lastIssueAt">
        <th mat-header-cell *matHeaderCellDef>{{'kiosksync.table.header.lastIssueAt'|traduccion}}</th>
        <td mat-cell *matCellDef="let kioskSync">{{ formatDateTime(kioskSync.lastIssueAt) }}</td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>{{'kiosksync.table.header.updatedAt'|traduccion}}</th>
        <td mat-cell *matCellDef="let kioskSync">{{ formatDateTime(kioskSync.updatedAt) }}</td>
      </ng-container>
    </app-data-table>
  </mat-card>
</div>
